import { TranslationTree } from "@/translations";
import { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { StopCircle } from "lucide-react";

export default function CountdownButton({
  initialSeconds,
  onStop,
  t,
}: {
  initialSeconds: number;
  onStop: () => void;
  t: TranslationTree;
}) {
  const [countdown, setCountdown] = useState(initialSeconds);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (countdown > 0) {
      interval = setInterval(() => {
        setCountdown((prevCount) => prevCount - 1);
      }, 1000);
    } else if (countdown === 0) {
      onStop();
    }
    return () => clearInterval(interval);
  }, [countdown, onStop]);

  return (
    <Button
      onClick={onStop}
      variant="destructive"
      className="w-full"
      aria-label={`Recording in progress. ${countdown} seconds remaining`}
    >
      <StopCircle className="mr-2 h-4 w-4" />
      {t.FACE_VERIFICATION.LABELS.STOP_BUTTON} ({countdown}s)
    </Button>
  );
}
